import { jsPDF } from 'jspdf';
import type { MonthlyReport } from '@getpay93/api';

function csvCell(v: string | number): string {
  const s = String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function reportToCsv(report: MonthlyReport): string {
  const header = 'Cliente,Monto,Vencimiento,Estado';
  const rows = report.lines.map((l) => [csvCell(l.clientName), csvCell(l.amount), csvCell(l.dueDate), csvCell(l.status)].join(','));
  return [header, ...rows].join('\n');
}

export function downloadBlob(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export function downloadCsv(filename: string, csv: string): void {
  downloadBlob(filename, new Blob([csv], { type: 'text/csv;charset=utf-8' }));
}

export function reportToPdf(report: MonthlyReport): void {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  doc.setFontSize(18);
  doc.text(`GetPay93 — Reporte ${report.label}`, 40, 50);
  doc.setFontSize(11);
  doc.text(`Cobrado: $${report.totals.collected.toFixed(2)}   Pendiente: $${report.totals.pending.toFixed(2)}   Vencido: $${report.totals.overdue.toFixed(2)}`, 40, 74);
  doc.text(`Tasa de cobro: ${Math.round(report.totals.collectionRate * 100)}%   Clientes activos: ${report.counts.activeClients}`, 40, 90);
  let y = 124;
  doc.setFontSize(12);
  doc.text('Cliente', 40, y);
  doc.text('Monto', 300, y);
  doc.text('Vence', 380, y);
  doc.text('Estado', 470, y);
  doc.setFontSize(10);
  y += 18;
  for (const l of report.lines) {
    if (y > 780) { doc.addPage(); y = 50; }
    doc.text(String(l.clientName).slice(0, 40), 40, y);
    doc.text(`$${l.amount.toFixed(2)}`, 300, y);
    doc.text(l.dueDate, 380, y);
    doc.text(l.status, 470, y);
    y += 16;
  }
  doc.save(`reporte-${report.label}.pdf`);
}
